var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',[_c('a-field',{directives:[{name:"bullets",rawName:"v-bullets"}],attrs:{"config":_vm.config[_vm.fieldName]},model:{value:(_vm.extraInfo),callback:function ($$v) {_vm.extraInfo=$$v},expression:"extraInfo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }